module.exports = __webpack_public_path__ + "static/img/chance.f632ee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s32/chance.png
// module id = AxNv
// module chunks = 2